<app-loader [isLoader]="loading"></app-loader>
<div class="modal-overlay" [ngClass]="{'show': isOpen}">
    <div class="modal-backdrop"></div>
    <div class="modal-container" (click)="$event.stopPropagation()">

        <div class="modal-header">
            <div class="header-title">
                <h2>{{isViewForm ? 'View Segment' : editMode ? 'Update Segment' : 'Create Segment'}}</h2>
                @if(isViewForm){
                    <i class="material-icons edit-icon" (click)="onEdit()">create</i>
                }
            </div>
            <button class="close-btn" (click)="onCancel()">
                <span>&times;</span>
            </button>
        </div>

        <div class="modal-body">
            <form [formGroup]="createSegmentForm" (ngSubmit)="onSubmit()">

                <div class="form-row" [ngClass]="{'view-only': isViewForm}">
                    <div class="form-group">
                        <label for="name">Segment Name <span class="requird">*</span></label>
                        <div class="input-with-icon">
                            <input type="text" id="name" formControlName="name" placeholder="Enter segment name"
                                class="form-control">
                        </div>

                        @if(createSegmentForm.get('name')?.invalid && createSegmentForm.get('name')?.touched){
                        <div class="error-message">
                            Please enter a segment name
                        </div>
                        }
                    </div>

                    <div class="form-group" [ngClass]="{'disabled': editMode,'view-only': isViewForm}">
                        <label>Segment Type <span class="requird">*</span></label>
                        <div class="radio-group">
                            <label class="radio-option">
                                <input type="radio" name="segment_type" formControlName="segment_type" value="standard"
                                    (change)="onSegmentTypeChange($event)" />
                                <span>Standard</span>
                            </label>
                            <label class="radio-option">
                                <input type="radio" name="segment_type" formControlName="segment_type" value="custom"
                                    (change)="onSegmentTypeChange($event)" />
                                <span>Custom</span>
                            </label>
                        </div>
                        @if(createSegmentForm.get('segment_type')?.invalid &&
                        createSegmentForm.get('segment_type')?.touched){
                        <div class="error-message">
                            Please select a valid segment type
                        </div>
                        }
                    </div>

                    @if(!editMode && !isViewForm) {
                        <div class="form-group full-width custom-segment-id-toggle-row">
                            <label class="toggle-switch">
                                <input type="checkbox" [checked]="specifyCustomSegmentId" (change)="onCustomSegmentIdToggle()">
                                <span class="toggle-slider"></span>
                            </label>
                            <span class="toggle-label">Specify custom segment ID</span>
                        </div>

                        @if(specifyCustomSegmentId) {
                            <div class="form-group full-width">
                                <div class="custom-segment-id-card"
                                    [class.card-available]="customSegmentIdStatus === 'available'"
                                    [class.card-unavailable]="customSegmentIdStatus === 'unavailable'">
                                    <div class="csi-label">Custom Segment ID <span class="requird">*</span></div>
                                    <div class="csi-input-wrapper"
                                        [class.input-available]="customSegmentIdStatus === 'available'"
                                        [class.input-unavailable]="customSegmentIdStatus === 'unavailable'">
                                        <span class="csi-prefix">sp_</span>
                                        <input #customSegmentIdInput
                                            type="text" formControlName="custom_segment_id"
                                            placeholder="Enter your segment ID suffix"
                                            class="form-control"
                                            maxlength="29"
                                            (blur)="onCustomSegmentIdFocusChange()">
                                    </div>
                                    @if((createSegmentForm.get('custom_segment_id')?.value?.length ?? 0) >= 29) {
                                        <div class="csi-status unavailable">
                                            <i class="material-icons">warning</i> Maximum length reached — Custom Segment IDs cannot exceed 32 characters (including the <strong>sp_</strong> prefix).
                                        </div>
                                    }
                                    @if(customSegmentIdSubmitAttempted && (createSegmentForm.get('custom_segment_id')?.value?.length ?? 0) < 12) {
                                        <div class="csi-status unavailable">
                                            <i class="material-icons">warning</i> Custom Segment ID is too short. Enter at least <strong>12</strong> characters after <strong>sp_</strong> (15–32 total characters).
                                        </div>
                                    }
                                    @if(customSegmentIdStatus === 'checking') {
                                        <div class="csi-status checking">Checking availability...</div>
                                    }
                                    @if(customSegmentIdStatus === 'available') {
                                        <div class="csi-status available">
                                            <i class="material-icons">check_circle</i> Available
                                        </div>
                                    }
                                    @if(customSegmentIdStatus === 'unavailable') {
                                        <div class="csi-status unavailable">
                                            <i class="material-icons">cancel</i> ID is not available, create a unique ID
                                        </div>
                                    }
                                    <div class="csi-hint">
                                        <i class="material-icons">info</i>
                                        The prefix <strong>sp_</strong> is fixed. Enter a suffix of 12–29 characters (total length 15–32).
                                    </div>
                                </div>
                            </div>
                        }
                    }

                    <div class="form-group" [ngClass]="{'view-only': isViewForm}">
                        <label for="provider_element_id">Provider Element Id <span class="requird">*</span>
                            <small class="hint">
                                (e.g. -100516)
                                <button type="button" class="hint-copy-btn" (click)="copyExample('-100516','Provider Element Id')"
                                    title="Copy example value">
                                    <i class="material-icons">content_copy</i>
                                </button>
                            </small>
                        </label>
                        <div class="input-with-copy">
                            <input type="number" id="provider_element_id" formControlName="provider_element_id"
                                placeholder="Enter provider element id" class="form-control">
                        </div>
                        @if(createSegmentForm.get('provider_element_id')?.invalid &&
                        createSegmentForm.get('provider_element_id')?.touched){
                        <div class="error-message">
                            @if (createSegmentForm.get('provider_element_id')?.errors?.['required']) {
                            <div>Please enter a parent element id</div>
                            }
                            @if (createSegmentForm.get('provider_element_id')?.errors?.['nonZeroInteger']) {
                            <div>Please enter a valid non-zero integer, e.g., -324234 or 3423342</div>
                            }
                        </div>
                        }
                    </div>

                    <div class="form-group" [ngClass]="{'view-only': isViewForm}">
                        <label for="content_pool">Content Pool</label>
                        <app-shared-dropdown-component id="content_pool" [title]="'Content Pool'" [items]="contentPool"
                            [selectItems]="ContentPoolFormArray"
                            (itemChange)="addItemInFormArray($event.event, $event.data, 'content_pool')"
                            (removeItem)="removeItemFormArray($event, 'content_pool')"
                            (selectAllChange)="checkedAll($event.target.checked,contentPool,'content_pool')"
                            (clearAll)="checkedAll(false,[],'content_pool')" [customWidth]="false">
                        </app-shared-dropdown-component>
                    </div>

                    @if(!hidePartnerId){
                        <div class="form-group" [ngClass]="{'view-only': isViewForm}">
                            <label for="partner_id">Partner Id
                                <small class="hint">
                                    (e.g. bip9el0)
                                    <button type="button" class="hint-copy-btn" (click)="copyExample('bip9el0','Partner Id')"
                                        title="Copy example value">
                                        <i class="material-icons">content_copy</i>
                                    </button>
                                </small>
                            </label>
                            <div class="input-with-copy">
                                <input type="text" id="partner_id" formControlName="partner_id" placeholder="Enter partner ids"
                                    class="form-control">
                            </div>
                            @if(createSegmentForm.get('partner_id')?.invalid &&
                            createSegmentForm.get('partner_id')?.touched){
                            <div class="error-message">
                                Please enter a valid partner id separated by comma
                            </div>
                            }
                        </div>
                    }

                    <div class="form-group full-width segment-mapping-section">
                        <label>Segment Mapping <span class="requird">*</span></label>

                        <div class="mapping-tabs" [ngClass]="{'view-only': isViewForm}">
                            <button type="button"
                                class="tab-btn"
                                [class.active]="activeTab === 'segment-list'"
                                [class.tab-btn--locked]="isTabSwitchLocked && activeTab !== 'segment-list'"
                                [disabled]="isTabSwitchLocked && activeTab !== 'segment-list'"
                                [title]="isTabSwitchLocked && activeTab !== 'segment-list' ? 'Cannot switch tabs: segment is approved' : ''"
                                (click)="onTabSwitch('segment-list')">
                                Segment List
                                @if (isTabSwitchLocked && activeTab !== 'segment-list') {
                                    <i class="material-icons tab-lock-icon">lock</i>
                                }
                            </button>
                            <button type="button"
                                class="tab-btn"
                                [class.active]="activeTab === 'rule-based'"
                                [class.tab-btn--locked]="isTabSwitchLocked && activeTab !== 'rule-based'"
                                [disabled]="isTabSwitchLocked && activeTab !== 'rule-based'"
                                [title]="isTabSwitchLocked && activeTab !== 'rule-based' ? 'Cannot switch tabs: segment is approved' : ''"
                                (click)="onTabSwitch('rule-based')">
                                Rule Based
                                @if (isTabSwitchLocked && activeTab !== 'rule-based') {
                                    <i class="material-icons tab-lock-icon">lock</i>
                                }
                            </button>
                        </div>

                        @if(activeTab === 'segment-list') {
                            <div class="tab-content">
                                <div class="condition-mode-row" [ngClass]="{'view-only': isViewForm}">
                                    <span class="condition-mode-label">Condition mode</span>
                                    <div class="condition-chips-list">
                                        @for (ctrl of (SegmentListFormArray.controls | slice:0:3); track $index; let i = $index) {
                                            @if (i > 0) {
                                                <span class="condition-op-badge">{{ segmentListConditionMode }}</span>
                                            }
                                            <span class="condition-chip">{{ ctrl.value?.name }}</span>
                                        }
                                        @if (SegmentListFormArray.controls.length > 3) {
                                            <span class="condition-chip condition-chip--more">+{{ SegmentListFormArray.controls.length - 3 }} more</span>
                                        }
                                    </div>
                                    <div class="condition-toggle">
                                        <button type="button"
                                            [class.active]="segmentListConditionMode === 'OR'"
                                            (click)="onConditionModeChange('OR')">OR</button>
                                        <button type="button"
                                            [class.active]="segmentListConditionMode === 'AND'"
                                            (click)="onConditionModeChange('AND')">AND</button>
                                    </div>
                                </div>
                                <app-shared-dropdown-component id="segment_list" [title]="'Select segment list'" [items]="segmentList"
                                    [selectItems]="SegmentListFormArray"
                                    (itemChange)="addItemInFormArray($event.event, $event.data, 'segment_list')"
                                    (removeItem)="removeItemFormArray($event, 'segment_list')"
                                    (selectAllChange)="checkedAll($event.target.checked,segmentList,'segment_list')"
                                    (clearAll)="checkedAll(false,[],'segment_list')" [customWidth]="false">
                                </app-shared-dropdown-component>
                            </div>
                        }

                        @if(activeTab === 'rule-based') {
                            <div class="tab-content">
                                <app-rule-based-mapping
                                    [availableSegments]="segmentList"
                                    [isViewOnly]="isViewForm"
                                    [initialRuleLogic]="initialRuleLogic"
                                    [submitted]="ruleBasedSubmitted"
                                    (ruleLogicChange)="onRuleLogicChange($event)">
                                </app-rule-based-mapping>
                            </div>
                        }
                    </div>

                    <div class="content-pool-status-section">
                        <app-content-pool-status [maxDisplayItems]="5"></app-content-pool-status>
                    </div>
                </div>
            </form>
        </div>

        <div class="modal-footer">
            <button type="button" class="btn btn-secondary" (click)="onCancel()">
                Cancel
            </button>
            @if(editMode && !isViewForm){
            <button type="button" class="btn btn-primary" (click)="updateSegment()"
                [disabled]="isSubmitDisabled">
                <span>Update Segment</span>
            </button>
            }
            @else if(!editMode && !isViewForm){
            <button type="button" class="btn btn-primary" (click)="onSubmit()"
                [disabled]="isSubmitDisabled">
                <span>Create Segment</span>
            </button>
            }
        </div>
    </div>
</div>